import { AbTestEditModel } from "@playcharge/common/models/backend/ab-tests/ab-test-edit-model";
import { inject, computed } from "@angular/core";
import { signalStore, withComputed, withMethods, patchState, withHooks } from "@ngrx/signals";
import { rxMethod } from "@ngrx/signals/rxjs-interop";
import { tap, pipe, filter, switchMap, Observable } from "rxjs";
import {
    withRequestStatus,
    setPending,
    setFulfilled,
    setError,
} from "../extensions/request-status.feature";
import { withRouteParams } from "../extensions/route-params.feature";
import { AbTestsStore } from "./ab-tests.store";
import { ApiAbTestsService } from "../../services/api-ab-tests.service";
import { AbTestViewModel } from "@playcharge/common/models/backend/ab-tests/ab-test-view-model";

export type AbTestStore = InstanceType<typeof AbTestStore>;

export const AbTestStore = signalStore(
    withRouteParams({ abTestId: (param) => Number(param) }),
    withRequestStatus(),
    withComputed(({ abTestId }, abTestsStore = inject(AbTestsStore)) => ({
        abTest: computed(() => (abTestId() ? abTestsStore.entityMap()[abTestId()] : null)),
    })),
    withMethods(
        (
            store,
            abTestsStore = inject(AbTestsStore),
            apiAbTestsService = inject(ApiAbTestsService),
        ) => ({
            loadTest: rxMethod<number>(
                pipe(
                    filter((id) => !!Number(id) && !store.abTest()),
                    tap(() => patchState(store, setPending())),
                    switchMap((id) => {
                        return apiAbTestsService.getTestById(id).pipe(
                            tap({
                                next: (abTest) => {
                                    patchState(store, setFulfilled());

                                    abTestsStore.setTest(abTest);
                                },
                                error: (error) => patchState(store, setError(error.error.error)),
                            }),
                        );
                    }),
                ),
            ),
            updateTest(model: AbTestEditModel): Observable<AbTestViewModel> {
                return apiAbTestsService
                    .updateTest(model)
                    .pipe(tap((abTest) => abTestsStore.setTest(abTest)));
            },
        }),
    ),
    withHooks({
        onInit({ loadTest, abTestId }) {
            loadTest(abTestId);
        },
    }),
);
